import * as $ from 'jquery';
import {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import Cookies from 'cookies-js';
import {CookieConstant} from '../constants';
import EventHub from '../eventHub';
import LtCommon from 'types/lt/ltCommon';

export default class ApiService implements LtCommon.IApiService {
    public loading: boolean = false;
	protected axiosInstance: AxiosInstance;
    private loadingCount: number = 0;
	private readonly source: string;

    constructor(source: string, axiosInstance: AxiosInstance) {
		this.source = source;
		this.axiosInstance = axiosInstance;
		this.axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
			this.updateLoading(true, (config as LtCommon.IAxiosRequestConfig).ignoreLoading);

			const ssoId: string = Cookies.get(CookieConstant.ssoId);
			if (ssoId) {
				config.headers = $.extend({}, config.headers, {'X-LTF-SSOID': ssoId});
			}

			const profileToken: string = Cookies.get(CookieConstant.profileToken);
			if (profileToken) {
				config.headers = $.extend({}, config.headers, { 'X-LTF-PROFILE': profileToken});
			}

			return config;
        }, (error) => {
            this.updateLoading(false);

            return $.Deferred().reject(error);
        });

		this.axiosInstance.interceptors.response.use((response: AxiosResponse) => {
            this.updateLoading(false,  (response.config as LtCommon.IAxiosRequestConfig).ignoreLoading);

            return response;
        }, (error: object) => {
            this.updateLoading(false);

            return $.Deferred().reject(error);
        });
    }

    private updateLoading(increment: boolean, ignoreLoading?: boolean): void {
        if (!ignoreLoading) {
            this.loadingCount += increment ? 1 : -1;
            this.loading = this.loadingCount > 0;
        }

        EventHub.$emit(this.source + '-loading', this.loading);
    }
}
